import { reducer as shm } from '@features/shm';

const rootReducer = { shm };

export type RootReducerType = typeof rootReducer;

export default rootReducer;
